import React from 'react';
import styled from '@emotion/styled';
import { rem } from 'polished';
import { text, colors, spaces } from '../../../core/styles/theme/default';

const StyledLabel = styled.label`
  ${text.p4};
  color: ${colors.nightBlue500};
  margin-bottom: calc(${rem(spaces.alpha)} / 2);
`;

const Label = ({ text, ...rest }: LabelProps) => {
  return <StyledLabel {...rest}>{text}</StyledLabel>;
};

export type LabelProps = {
  /** Text for Error Message */
  text: string;
};

export default Label;
